import { render } from "./TvmMyAddress.vue?vue&type=template&id=8262d328&scoped=true"
import script from "./TvmMyAddress.vue?vue&type=script&lang=js"
export * from "./TvmMyAddress.vue?vue&type=script&lang=js"

import "./TvmMyAddress.vue?vue&type=style&index=0&id=8262d328&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8262d328"],['__file',"src/components/ChatWidget/TvmMyAddress/TvmMyAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8262d328"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8262d328', __exports__)) {
    api.reload('8262d328', __exports__)
  }
  
  module.hot.accept("./TvmMyAddress.vue?vue&type=template&id=8262d328&scoped=true", () => {
    api.rerender('8262d328', render)
  })

}


export default __exports__